
<div  class="error-message-container">
    <app-error-message *ngIf="message!=''" [message]="message"></app-error-message>
</div>
<h1>כניסה ליישומים מזוהים </h1>
<p>
    עבור עובדים שמספר הטלפון הנייד שלהם מעודכן במערכות משרד החינוך
</p>

<form [formGroup]="passWordForm" id="idCardForm">
    <div class="inputs-button-wrapper">
        <label for="userName" class="eds-input-label"><span class="lable-b">קוד משתמש</span> (משרדי)</label>
        <div class='inputs-container'>
            <input autofocus tabindex="1" autocomplete="off" readonly  onfocus="this.removeAttribute('readonly')" #userName id="userName" formControlName="userName"
            placeholder="לדוגמה kl987"  type="text" (input) = "clearCursor('userName');message!='' && resetMassage()" (focusout)="clearDirective()"
            [ngClass]="{inputInvalid:hebrewCharater == userName.id ||(isValidFormSubmitted && passWordForm.controls['userName'].errors?.required)}" 
             pInputText (hebrewCharater)="hebrewCharater=$event" (capsLock)="capsOn=$event">
            <p-message severity="error" text="קוד המשתמש שלך לא חוקי" *ngIf="userName.invalid && userName.touched">
            </p-message>
            <label *ngIf="capsOn == userName.id" class="caps-in-on">Caps Lock פעיל</label>
            <p-message severity="error" text="אין להקליד תווים בעברית" *ngIf="hebrewCharater == userName.id">
            </p-message>
            <p-message severity="error" text="שדה חובה"  *ngIf="isValidFormSubmitted && passWordForm.controls['userName'].errors?.required">
            </p-message>
        </div>
        <label for="password" class="eds-input-label"><span class="lable-b">סיסמה</span> (משרדית)</label>
        <div class='inputs-container'>
            <div class="password-contianer">
                <input #password tabindex="2" autocomplete="off" readonly  onfocus="this.removeAttribute('readonly')"  id="password" formControlName="password" maxlength="16" type="password" (input) = "clearCursor('password');message!='' && resetMassage()" 
                 pInputText togglePassword (hebrewCharater)="hebrewCharater=$event" (capsLock)="capsOn=$event" (focusout)="clearDirective()"
                [ngClass]="{inputInvalid:(hebrewCharater == password.id  || (isValidFormSubmitted && passWordForm.controls['password'].errors?.required))}" >
            </div>
            <p-message severity="error" text="סיסמה לא תקינה" *ngIf="password.invalid && password.touched">
            </p-message>
            <p-message severity="error" text="שדה חובה"  *ngIf="isValidFormSubmitted && passWordForm.controls['password'].errors?.required">
            </p-message>
            <label *ngIf="capsOn == password.id" class="caps-in-on">Caps Lock פעיל</label>
            <p-message  severity="error" text=" אין להקליד תווים בעברית" *ngIf="hebrewCharater == password.id">
            </p-message>
        </div>
        <div class="forget-password">
        <div class="create-password">
            <a target='_blank' rel="noopener noreferrer" href={{this.resetPassword}}>
                שכחתי סיסמה
            </a>
        </div>
        <div class="tooltip-help"><span class="tooltiptext">ניתן לגשת לשירות זה <br>רק מתוך הרשת המשרדית</span></div></div>
        <div class="container-button container-fluid">
            <p-button class='btn-moe' type="submit" label="שלחו לי קוד" (onClick)="CaptchaNeeded ? captchaRef.execute() : onSubmit()">
            </p-button>
            <span class="cesher-phone">הודעה קולית תישלח לטלפונים כשרים</span>
        </div>
    </div>
    <re-captcha #captchaRef="reCaptcha" (resolved)="$event && onSubmit($event)" siteKey="{{this.sitekey}}" size="invisible" ></re-captcha> 
</form>
<div class="reminder" >להזכירך, פרטי ההזדהות אישיים וחסויים וחל איסור על העברתם</div>


<app-loader *ngIf="loader"  [text]="'המערכת בודקת את הנתונים'"></app-loader>
